'use client';

import noop from 'lodash/noop';
import React, { createContext, useContext } from 'react';
import { InstantPayoutsModalScreens } from './constants';
import type { PrimaryButtonProps, SecondaryButtonProps } from './types';

export interface CurrentViewContextProps {
  currentScreen: InstantPayoutsModalScreens;
  setCurrentScreen: (screen: InstantPayoutsModalScreens) => void;
  primaryButtonConfigs: PrimaryButtonProps;
  setPrimaryButtonConfigs: (configs: PrimaryButtonProps) => void;
  secondaryButtonConfigs: SecondaryButtonProps;
  setSecondaryButtonConfigs: (configs: SecondaryButtonProps) => void;
}

const CurrentViewContext = createContext<CurrentViewContextProps>({
  currentScreen: InstantPayoutsModalScreens.EnterAmountScreen,
  primaryButtonConfigs: {},
  secondaryButtonConfigs: {},
  setPrimaryButtonConfigs: noop,
  setSecondaryButtonConfigs: noop,
  setCurrentScreen: noop,
});

export const CurrentViewContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [primaryButtonConfigs, setPrimaryButtonConfigs] = React.useState<PrimaryButtonProps>({});
  const [secondaryButtonConfigs, setSecondaryButtonConfigs] = React.useState<SecondaryButtonProps>(
    {},
  );
  const [currentScreen, setCurrentScreen] = React.useState<InstantPayoutsModalScreens>(
    InstantPayoutsModalScreens.EnterAmountScreen,
  );

  return (
    <CurrentViewContext.Provider
      value={{
        primaryButtonConfigs,
        setPrimaryButtonConfigs,
        secondaryButtonConfigs,
        setSecondaryButtonConfigs,
        currentScreen,
        setCurrentScreen,
      }}
    >
      {children}
    </CurrentViewContext.Provider>
  );
};

export const useCurrentViewContext = () => useContext(CurrentViewContext);
